/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=0132f0dc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0132f0dc&lang=css"

import exportComponent from "/Users/zhangwenting/Code/Vlian/vlian-pc-vue3/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__